import { isRecord } from '@cascade/core/utils';
import type { THeroRotation } from './Hero.types.ts';

const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const HERO_ROTATION_KEY = 'cascade.authentication.hero';

export const heroImages = [
  '/authentication/1.webp',
  '/authentication/2.webp',
  '/authentication/3.webp',
  '/authentication/4.webp',
  '/authentication/5.webp',
  '/authentication/6.webp',
];

const isImageIndex = (value: unknown): value is number =>
  typeof value === 'number' &&
  Number.isInteger(value) &&
  value >= 0 &&
  value < heroImages.length;

const isTimestamp = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export const advanceRotation = (
  stored: THeroRotation | undefined,
  now: number,
): THeroRotation => {
  if (!stored) {
    return { index: 0, rotatedAt: now };
  }

  const daysPassed = Math.max(
    0,
    Math.floor((now - stored.rotatedAt) / DAY_IN_MILLISECONDS),
  );

  return {
    index: (stored.index + daysPassed) % heroImages.length,
    rotatedAt: stored.rotatedAt + daysPassed * DAY_IN_MILLISECONDS,
  };
};

export const toRotation = (value: unknown): THeroRotation | undefined => {
  if (
    !isRecord(value) ||
    !isImageIndex(value.index) ||
    !isTimestamp(value.rotatedAt)
  ) {
    return undefined;
  }

  return { index: value.index, rotatedAt: value.rotatedAt };
};
